export default __webpack_public_path__ + "static/media/areadedropoff.4cb99aab.svg";